<template>
    <inertia-link :href="'/'" class="flex items-center ">
        <img :src="logoUrl" class="w-8 h-8 md:w-9 md:h-9">

        <div v-if="!logoOnly" class="hidden md:block ml-2 mr-6 text-xl md:text-2xl font-normal lg:font-bold "
            style="font-family: 'Roboto', sans-serif;">
            humtt
        </div>
    </inertia-link>
</template>

<script>
export default {
    props: {
        size: {
            type: [Number, String],
            default: 10,
        },
        logoOnly: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        logoUrl() {
            return `${process.env.MIX_SENTRY_DSN_PUBLIC}/storage/default/logo.png`;
        },
    },
};
</script>
